import { FC, ReactNode } from "react";
import { Grid, useMediaQuery } from "@material-ui/core";

import theme from "theme";

interface SwapContentLayoutProps {
  primary: ReactNode;
  secondary: ReactNode;
  swap: boolean;
}

const SwapContentLayout: FC<SwapContentLayoutProps> = ({
  primary,
  secondary,
  swap,
}) => {
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Grid container spacing={isSmDown ? 2 : 8}>
      <Grid item xs={12} md={6}>
        {swap ? secondary : primary}
      </Grid>
      <Grid item xs={12} md={6}>
        {swap ? primary : secondary}
      </Grid>
    </Grid>
  );
};

export default SwapContentLayout;
